import { groupArrayToMap } from './group-array-to-map';

/**
 * Group an array by a selector and returns an array.
 * If you want a mapped result, use `groupArrayToMap` instead.
 *
 * @param arr - The array to group
 * @param groupingFunc - The grouping function
 * @returns the array grouped
 */
export function groupArray<T, Group>(arr: T[], groupingFunc: (item: T) => Group): Array<[Group, T[]]> {
    return Array.from(groupArrayToMap(arr, groupingFunc));
}
